import styled from "styled-components"

const MessagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start; // This is key
  /* Freede palette: blue gradient for the consumer, translucent white card
     for the coach — mirrors the platform's dark glassy look. */
  --sentColor: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  --receiveColor: rgba(255, 255, 255, 0.1);
  --bg: transparent;
  list-style: none;
  position: relative;
  padding-top: 10px;
  padding-left: 15px;
  padding-right: 15px;
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100 * var(--vh));

  @media (max-width: 480px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`;

export default MessagesContainer;
